import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-slate-700 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center mb-3">
              <img 
                src="/assets/seedsynch-logo-lockup.svg" 
                alt="SeedSynch" 
                className="h-10"
              />
            </div>
            <p className="text-slate-400 text-sm mb-4">Smarter matchmaking for founders and investors.</p>
            <a 
              href="https://www.linkedin.com/company/seedsynch" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-slate-400 hover:text-blue-400 transition-colors text-sm"
            >
              <Linkedin size={18} />
              <span>Follow SeedSynch on LinkedIn</span>
            </a>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/#how-it-works" className="text-slate-400 hover:text-blue-400">What to Expect</Link></li>
              <li><Link to="/#pricing" className="text-slate-400 hover:text-blue-400">Pricing</Link></li>
              <li><Link to="/blog" className="text-slate-400 hover:text-blue-400">Blog</Link></li>
              <li><Link to="/faq" className="text-slate-400 hover:text-blue-400">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-slate-400 hover:text-blue-400">About Us</Link></li>
              <li><Link to="/for-founders" className="text-slate-400 hover:text-blue-400">For Founders</Link></li>
              <li><Link to="/for-investors" className="text-slate-400 hover:text-blue-400">For Investors</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="text-slate-400 hover:text-blue-400">Privacy Policy</Link></li>
              <li><Link to="/terms-of-use" className="text-slate-400 hover:text-blue-400">Terms of Use</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-500 text-xs">
          <p>© 2026 SeedSynch. All rights reserved.</p>
          <p className="mt-2">SeedSynch is a discovery platform only. We do not provide financial advice or investment recommendations.</p>
          <p className="mt-4">
            <Link to="/unsubscribe" className="text-slate-500 hover:text-slate-400 transition-colors">
              Unsubscribe / Remove my data
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
